import { render, staticRenderFns } from "./terms-policy.vue?vue&type=template&id=2fd1a82d&scoped=true&"
import script from "./terms-policy.vue?vue&type=script&lang=js&"
export * from "./terms-policy.vue?vue&type=script&lang=js&"
import style0 from "./terms-policy.vue?vue&type=style&index=0&id=2fd1a82d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd1a82d",
  null
  
)

export default component.exports